<span class="primary" *ngIf="timerIsStarted">{{ minutesDisplay }} : {{ secondsDisplay }}</span>
